import { render } from "./UpdateServiceDataModal.vue?vue&type=template&id=3a2a4582"
import script from "./UpdateServiceDataModal.vue?vue&type=script&lang=js"
export * from "./UpdateServiceDataModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__